var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('div',{staticClass:"loader-overlay",style:(`background: rgba(255, 255, 255, ${_vm.opacity});`)},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }